import type { SignupDTO } from "../../domain/dto/SignupDTO";
import type { AuthRepository } from "../../domain/repositories/AuthRepository";
import type { RegistrationResponse } from "../../domain/entities/RegistrationResponse";

export const signupUser = async (
  repo: AuthRepository,
  data: SignupDTO,
): Promise<RegistrationResponse> => {
  return repo.signup(data);
};
